// extracted by mini-css-extract-plugin
module.exports = {"headerBar":"z-z","pointsSection":"A-z","goToDashboard":"B-z"};